import * as types from "./mutation-types";
import { backendAddress } from "@/utils/appSettings";
import Vue from "vue";

export default {
  [types.LOADING](state) {
    state.loading = true;
  },
  [types.LOADED](state) {
    state.loading = false;
  },
  [types.LOGIN](state) {
    state.isLoggedIn = true;
  },
  [types.LOGOUT](state) {
    state.isLoggedIn = false;
  },
  [types.SETLAYOUT](state, config) {
    var url = backendAddress();
    config.logo = url + "/" + config.logo;
    state.layoutConfig = config;
    state.originalLayoutConfig = JSON.parse(JSON.stringify(config));
  },
  [types.SETKEY](state) {
    state.key++;
  },
  [types.SETCONTRASTLAYOUT](state, contrast) {
    switch (contrast) {
      case "black": {
        state.layoutConfig.navbarBackgroundColor = "black";
        state.layoutConfig.titleColor = "white";
        state.layoutConfig.footerFontColor = "white";
        state.layoutConfig.footerBackgroundColor = "black";
        state.layoutConfig.backgroundColor = "#252525";
        break;
      }
      case "none": {
        state.layoutConfig = JSON.parse(
          JSON.stringify(state.originalLayoutConfig)
        );
      }
    }
    state.contrast = contrast;
  },
  [types.SETBASEFONTSIZE](state, size) {
    state.baseFontSize = parseInt(size.toString().trim());
  },
  [types.SET_COMPANY_NAME](state, companyName) {
    state.companyName = companyName;
  },
  [types.SET_LOCALES](state, locales) {
    state.locales = locales;
  },
  [types.PUSH_LOCALES](state, { company, locale }) {
    if (!state.locales) {
      state.locales = {};
    }

    let temp = {};
    Object.keys(state.locales).forEach(el => {
      Vue.set(temp, el, state.locales[el]);
    });
    Vue.set(temp, company, locale);
    state.locales = temp;

    console.log(temp);
  }
};
